import { useDispatch } from 'react-redux'
import {
  trackHomeDigestViewEvent,
  getHomeTrackingEventSubmitted,
} from '../actions/home'

const useTrackHomeEventOnce = eventName => {
  const dispatch = useDispatch()

  return () => {
    const tracked = getHomeTrackingEventSubmitted(eventName)

    if (eventName && !tracked) {
      dispatch(trackHomeDigestViewEvent(eventName))
    }
  }
}

export default useTrackHomeEventOnce
